import {
  OnAuthenticating,
  OnAuthenticationError,
  OnMemberInfoFetched
} from './member.types'

export const AUTHENTICATING = 'AUTHENTICATING'
export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR'
export const MEMBER_INFO_FETCHED = 'MEMBER_INFO_FETCHED'

export const onAuthenticating: OnAuthenticating = () => ({
  type: AUTHENTICATING
})

export const onMemberInfoFetched: OnMemberInfoFetched = response => ({
  payload: { response },
  type: MEMBER_INFO_FETCHED
})

export const onAuthenticationError: OnAuthenticationError = error => ({
  payload: { error },
  type: AUTHENTICATION_ERROR
})
